import React, { useState } from 'react';
import CreateIcon from '@mui/icons-material/Create';
import PersonalInfo from '../component/PersonalInfo';
import ChangePassword from '../component/ChangePassword';
import EditProfileModal from '../component/EditProfileModal';

const Settings = () => {
    const [isPersonalInfoVisible, setIsPersonalInfoVisible] = useState(true);
    const [isSubscriptionVisible, setIsSubscriptionVisible] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const togglePersonalInfo = () => {
        setIsPersonalInfoVisible(true);
        setIsSubscriptionVisible(false);
    };

    const toggleSubscription = () => {
        setIsPersonalInfoVisible(false);
        setIsSubscriptionVisible(true);
    };

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleSaveProfile = (data) => {
        console.log('Profile data:', data);
    };

    return (
        <div className='w-full px-3 sm:px-4 lg:px-6 py-4 lg:py-6 bg-gradient-to-br from-gray-50 to-gray-100/50 min-h-screen mt-8 lg:mt-0'>
            {/* Page Header */}
            <div className='mb-6'>
                <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3'>
                    <div>
                        <h1 className='text-2xl lg:text-3xl font-bold text-gray-800 flex items-center gap-2'>
                            <span>⚙️</span> Settings
                        </h1>
                        <p className='text-sm text-gray-500 mt-1'>
                            Manage your profile and account settings
                        </p>
                    </div>
                    <div className='flex items-center gap-2 text-sm text-gray-500 bg-white px-4 py-2 rounded-xl shadow-sm'>
                        <span className='inline-block w-2 h-2 bg-green-500 rounded-full animate-pulse'></span>
                        Live
                    </div>
                </div>
            </div>

            <div className='bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden'>
                {/* Tabs */}
                <div className='flex flex-col sm:flex-row items-start sm:items-center justify-between p-4 lg:p-6 border-b border-gray-100 gap-3'>
                    <div className='flex gap-2 sm:gap-4 w-full sm:w-auto'>
                        <button 
                            onClick={togglePersonalInfo} 
                            className={`px-4 py-2 rounded-xl text-sm font-medium transition-all duration-200 ${
                                isPersonalInfoVisible 
                                    ? 'bg-[#069125] text-white shadow-lg shadow-[#069125]/30' 
                                    : 'text-gray-600 hover:bg-gray-100'
                            }`}
                        >
                            👤 Personal Info
                        </button>
                        <button 
                            onClick={toggleSubscription} 
                            className={`px-4 py-2 rounded-xl text-sm font-medium transition-all duration-200 ${
                                isSubscriptionVisible 
                                    ? 'bg-[#069125] text-white shadow-lg shadow-[#069125]/30' 
                                    : 'text-gray-600 hover:bg-gray-100'
                            }`}
                        >
                            🔒 Change Password
                        </button>
                    </div>

                    <div className='w-full sm:w-auto'>
                        {isPersonalInfoVisible && (
                            <button
                                onClick={handleOpenModal}
                                className='w-full sm:w-auto flex items-center justify-center gap-2 bg-[#069125] text-white font-medium py-2 px-4 rounded-xl hover:bg-[#057a1f] transition-all duration-200 hover:shadow-lg hover:shadow-[#069125]/30 text-sm'
                            >
                                <CreateIcon className='text-sm' />
                                <span>Edit Profile</span>
                            </button>
                        )}
                    </div>
                </div>

                {/* Content */}
                <div className='p-4 lg:p-6'>
                    {isPersonalInfoVisible && (
                        <div className='animate-fadeIn'>
                            <PersonalInfo />
                        </div>
                    )}

                    {isSubscriptionVisible && (
                        <div className='animate-fadeIn'>
                            <ChangePassword />
                        </div>
                    )}
                </div>
            </div>

            {/* Edit Profile Modal */}
            <EditProfileModal 
                isOpen={isModalOpen} 
                onClose={handleCloseModal} 
                onSave={handleSaveProfile} 
            />
        </div>
    );
};

export default Settings;